
import Vue from "vue";
import Search from "@/components/Search.vue";
import { Component, Ref } from "vue-property-decorator";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import ChatTicketModel from "@/models/createTicket/ChatTicketModel";
import utils from "@/utils";
import { UserModule } from "@/store/modules/user";
import HelperModel from "@/models/HelperModel";
@Component({
  components: {
    Search,
  },
})
export default class Chat extends Vue {
  mounted() {
    this.getDetailTicket(this.$route.params.id).then(() => {
      this.getListChat(this.$route.params.id);
    });
  }
  utils = utils;
  userDetail = UserModule.userDetail;
  titlePage = "Cake Engine Breaking Down";
  filename: File | null = null;

  helper: HelperModel = new HelperModel();
  ticket: TicketModel = new TicketModel();
  listChat: ChatTicketModel[] = [];
  chatTicket: ChatTicketModel = new ChatTicketModel();
  @Ref() fileAttach!: HTMLElement;
  @Ref() formChat!: HTMLFormElement;

  getImage() {
    if (this.fileAttach) {
      this.fileAttach.click();
    }
  }
  onSelectFile(payload) {
    const input = payload.target;
    const files = input.files;
    if (files && files[0]) {
      const reader = new FileReader();
      if (
        files[0].type === "image/png" ||
        files[0].type === "image/jpg" ||
        files[0].type === "image/jpeg"
      ) {
        if (this.fileMaxImage(files[0].size, 10000)) {
          reader.onload = (payload) => {
            if (payload.target) {
              this.filename = files[0];
              if (this.filename) {
                api.helper
                  .uploadFile(this.filename, this.filename.name)
                  .then((response) => {
                    this.helper = Object.assign({}, response.data);
                    this.chatTicket.message = this.helper.media_url;
                    this.chatTicket.message_type = "image";
                    api.ticket
                      .sendChat(this.chatTicket, this.ticket.id)
                      .then((response) => {
                        if (response.data.code === 200) {
                          this.getListChat(this.ticket.id);
                          this.cancelChat();
                        }
                      })
                      .catch((err: any) => {
                        this.$swal("Error", err?.response?.data?.message, "error");
                      });
                  })
                  .catch((err) => {
                    this.$swal("Error", err?.response?.data?.message, "error");
                  });
              }
            }
          };
          reader.readAsDataURL(files[0]);
        }
      }
    }
  }
  fileMaxImage(size: number, max: number) {
    const maxFile = max * 1000;
    if (size <= maxFile) {
      return true;
    } else {
      return false;
    }
  }
  cancelChat() {
    this.chatTicket = new ChatTicketModel();
    this.filename = null;
  }
  getDetailTicket(idTicket: string) {
    return new Promise((resolve, reject) => {
      api.ticket
        .getDetailTask(idTicket)
        .then((response) => {
          if (response.data.code === 200) {
            this.ticket = Object.assign({}, response.data.data);
            resolve(response);
          }
        })
        .catch((err) => {
          reject(new Error(err));
        });
    });
  }
  getListChat(idTicket: string | null) {
    return new Promise((resolve, reject) => {
      api.ticket
        .getListChat(idTicket)
        .then((response) => {
          if (response.data.code === 200) {
            this.listChat = [...response.data.data.data];
            resolve(response);
          }
        })
        .catch((err) => {
          reject(new Error(err));
        });
    });
  }
  sendChat() {
    if (this.chatTicket.message) {
      this.chatTicket.message_type = "text";
      api.ticket
        .sendChat(this.chatTicket, this.ticket.id)
        .then((response) => {
          if (response.data.code === 200) {
            this.getListChat(this.ticket.id);
            this.cancelChat();
          }
        })
        .catch((err: any) => {
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    }
  }
}
